import { Unit } from "uom";
export var HumidityFactor = Unit.createBase("HumidityFactor", "RelativeHumidity", "r.H.");
/** Factor of humidity, eg., 0.01 means 1% */
export var PercentHumidity = Unit.divideNumber("PercentHumidity", 100.0, HumidityFactor);
//# sourceMappingURL=relative-humidity.js.map